/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TradePromo_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedPromoCode_item$ref: FragmentReference;
export type PdpSharedPromoCode_item = {|
  +$fragmentRefs: TradePromo_item$ref,
  +$refType: PdpSharedPromoCode_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedPromoCode_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_item",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ea46f36575e44c5e9545ccb796db55f6';
module.exports = node;
